import { render, staticRenderFns } from "./AdvisoryFlowExternal.vue?vue&type=template&id=538c88dc&scoped=true"
import script from "./AdvisoryFlowExternal.vue?vue&type=script&lang=js"
export * from "./AdvisoryFlowExternal.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryFlowExternal.vue?vue&type=style&index=0&id=538c88dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c88dc",
  null
  
)

export default component.exports